import {
  NoResultLine,
  NoResultScreenSection,
  RetryBtn,
  SadImage,
  TrySearch,
} from './styled';

export default function Noresultscreen(props) {
  const { searchString, setSearchString } = props;
  const retryClickHandler = () => {
    document.getElementById('topicSearch').value = '';
    document.getElementById('topicSearch').focus();
    setSearchString('');
  };
  return (
    <NoResultScreenSection>
      <NoResultLine>
        No results found for <strong>&quot;{searchString}&quot;</strong>
      </NoResultLine>
      <div>
        <SadImage src="/images/sadcartemoji.gif" alt="" width="100px" />
      </div>
      <TrySearch>Try searching for some other topics</TrySearch>
      <RetryBtn onClick={retryClickHandler}>Retry</RetryBtn>
    </NoResultScreenSection>
  );
}
